import { ErrorBase } from './ErrorBase';

export class AuthError extends ErrorBase {
  constructor({ message, cause }: { message: string; cause: Error }) {
    super({ message, cause });
    this.name = 'AuthError';
  }
}
